<template>
  <div>
    <Button
      v-if="canAccess('merge_tools')"
      icon="fas fa-compress-alt"
      :text="breakpoints().sm ? 'Merge' : 'Merge Accounts'"
      class="whitespace-nowrap"
      @click="toggleModal"
    />
    <MergeAccountsModal v-if="mergeModal" @hide-modal="toggleModal" />
  </div>
</template>

<script>
import { useAccessRole } from "@/lib/useAccessRole";

import Button from "@/components/Button.vue";
import MergeAccountsModal from "./MergeAccountsModal.vue";
export default {
  components: {
    Button,
    MergeAccountsModal
  },
  setup() {
    const { canAccess } = useAccessRole();
    return {
      canAccess
    };
  },
  data() {
    return {
      mergeModal: false
    };
  },
  methods: {
    toggleModal() {
      this.mergeModal = !this.mergeModal;
    }
  }
};
</script>

<style lang="scss" scoped></style>
